import React, { useRef } from 'react';
import GundamCard from './GundamCard/GundamCard';
import OdArrowLeftIcon from '../../../../static/assets/svg/od-arrow-left-grey-icon.svg';
import OdArrowRightIcon from '../../../../static/assets/svg/od-arrow-right-grey-icon.svg';
import Slider from 'react-slick';
import './RecommendedList.scss';

const gundamData = [
  {
    modelNumber: 'GDM2003B-3A',
    name: 'ZEON EXCLUSIVE SPECTACLES',
    id: 221922,
    url: `gundam-gdm2003b-3a-c2-c2-eyeglasses.html`,
    color: '#434021',
    images: [
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c2-c2-eyeglasses_gdm2003b-3a_c2_01.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c2-c2-eyeglasses_gdm2003b-3a_c2_02.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c2-c2-eyeglasses_gdm2003b-3a_c2_03.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c2-c2-eyeglasses_gdm2003b-3a_c2_04.jpg',
    ],
    altImages: [
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c2-c2-eyeglasses_gdm2003b-3a_c2_02.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c2-c2-eyeglasses_gdm2003b-3a_c2_03.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c2-c2-eyeglasses_gdm2003b-3a_c2_04.jpg',
    ],
    price: 'S$198',
  },
  {
    modelNumber: 'GDM2003B-3A',
    name: 'ZEON EXCLUSIVE SPECTACLES',
    id: 221921,
    url: 'gundam-gdm2003b-3a-c1-c1-eyeglasses.html',
    color: '#bf1a21',
    images: [
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c1-c1-eyeglasses_gdm2003b-3a_c1_01.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c1-c1-eyeglasses_gdm2003b-3a_c1_02.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c1-c1-eyeglasses_gdm2003b-3a_c1_03.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c1-c1-eyeglasses_gdm2003b-3a_c1_04.jpg',
    ],
    altImages: [
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c1-c1-eyeglasses_gdm2003b-3a_c1_02.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c1-c1-eyeglasses_gdm2003b-3a_c1_03.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm2003b-3a-c1-c1-eyeglasses_gdm2003b-3a_c1_04.jpg',
    ],
    price: 'S$198',
  },
  {
    modelNumber: 'GDM1004B-3A',
    name: 'ZEON EXCLUSIVE SUNGLASSES',
    id: 221924,
    url: `gundam-gdm1004b-3a-c2-c2-sunglasses.html`,
    color: '#434021',
    images: [
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c2-c2-sunglasses_gdm1004b-3a_c2_01.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c2-c2-sunglasses_gdm1004b-3a_c2_02.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c2-c2-sunglasses_gdm1004b-3a_c2_03.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c2-c2-sunglasses_gdm1004b-3a_c2_04.jpg',
    ],
    altImages: [
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c2-c2-sunglasses_gdm1004b-3a_c2_02.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c2-c2-sunglasses_gdm1004b-3a_c2_03.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c2-c2-sunglasses_gdm1004b-3a_c2_04.jpg',
    ],
    price: 'S$78',
  },
  {
    modelNumber: 'GDM1004B-3A',
    name: 'ZEON EXCLUSIVE SUNGLASSES',
    id: 221923,
    url: 'gundam-gdm1004b-3a-c1-c1-sunglasses.html',
    color: '#dd342e',
    images: [
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c1-c1-sunglasses_gdm1004b-3a_c1_01.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c1-c1-sunglasses_gdm1004b-3a_c1_02.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c1-c1-sunglasses_gdm1004b-3a_c1_03.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c1-c1-sunglasses_gdm1004b-3a_c1_04.jpg',
    ],
    altImages: [
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c1-c1-sunglasses_gdm1004b-3a_c1_02.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c1-c1-sunglasses_gdm1004b-3a_c1_03.jpg',
      'https://static5.lenskart.com/media/catalog/product/pro/1/thumbnail/628x301/9df78eab33525d08d6e5fb8d27136e95//g/i/gundam-gdm1004b-3a-c1-c1-sunglasses_gdm1004b-3a_c1_04.jpg',
    ],
    price: 'S$78',
  },
  {
    id: 221925,
    url: 'gundam-zaku-case3a.html',
    name: 'ZEON EXCLUSIVE SPECTACLE CASE',
    modelNumber: 'ZAKU-CASE3A',
    images: [
      'https://static.lenskart.com/media/owndays/desktop/img/gundum/gallery-01.png',
      'https://static.lenskart.com/media/owndays/desktop/img/gundum/gallery-2.webp',
      'https://static.lenskart.com/media/owndays/desktop/img/gundum/gallery-3.webp',
      'https://static.lenskart.com/media/owndays/desktop/img/gundum/gallery-4.webp',
    ],
    altImages: [
      'https://static.lenskart.com/media/owndays/desktop/img/gundum/gallery-2.webp',
      'https://static.lenskart.com/media/owndays/desktop/img/gundum/gallery-3.webp',
      'https://static.lenskart.com/media/owndays/desktop/img/gundum/gallery-4.webp',
    ],
    price: 'S$498',
  },
];

const RecommendedList = ({ slideToShow, device, currentProductId }) => {
  const sliderRef = useRef(null);

  const config = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: slideToShow,
    slidesToScroll: 1,
    centerPadding: '40px',
  };

  return (
    <div className="od-recommended-list">
      <div className={device === 'mobile' ? '' : 'main-content-wrapper'}>
        <div className="od-pdp-rv">
          {device !== 'mobile' ? (
            <div className="od-pdp-rv__top">
              <div className="od-pdp-rv__top__title">Recommended Products</div>
              <div className="od-pdp-rv__range__wrapper">
                <img
                  alt="next"
                  className="od-pdp-rv__slider__prev"
                  src={OdArrowLeftIcon}
                  onClick={() => sliderRef.current.slickPrev()}
                />
                <img
                  alt="next"
                  className="od-pdp-rv__slider__next"
                  src={OdArrowRightIcon}
                  onClick={() => sliderRef.current.slickNext()}
                />
              </div>
            </div>
          ) : (
            <div className="od-recommended-list__mobile">Recommended Products</div>
          )}
          <Slider ref={sliderRef} {...config}>
            {gundamData.map(gundam => {
              console.log('gundam productssss ===>', gundam, currentProductId);
              if (gundam.id === Number(currentProductId)) {
                return null;
              }
              return <GundamCard key={gundam.id} product={gundam} />;
            })}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default RecommendedList;
